export const CONTEXT_MENU_ITEM_SELECTOR = '[role="menuitem"]:not([aria-disabled="true"])'

export function listEnabledContextMenuItems(menuRoot: HTMLElement): HTMLElement[] {
  return Array.from(menuRoot.querySelectorAll<HTMLElement>(CONTEXT_MENU_ITEM_SELECTOR))
}

/** Move keyboard highlight; `current === -1` means nothing highlighted yet. */
export function nextContextMenuIndex(current: number, delta: number, itemCount: number): number {
  if (itemCount <= 0) return -1

  if (current < 0) {
    return delta > 0 ? 0 : itemCount - 1
  }

  return (current + delta + itemCount) % itemCount
}

export function applyContextMenuHighlight(menuRoot: HTMLElement, activeIndex: number): void {
  const items = listEnabledContextMenuItems(menuRoot)

  items.forEach((el, idx) => {
    if (idx === activeIndex) {
      el.setAttribute('data-highlighted', 'true')
      el.scrollIntoView({ block: 'nearest' })
    } else {
      el.removeAttribute('data-highlighted')
    }
  })
}

export function clearContextMenuHighlight(menuRoot: HTMLElement): void {
  listEnabledContextMenuItems(menuRoot).forEach((el) => {
    el.removeAttribute('data-highlighted')
  })
}
